var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-select',{attrs:{"options":_vm.options},on:{"change":_vm.change},model:{value:(_vm.incoterms),callback:function ($$v) {_vm.incoterms=$$v},expression:"incoterms"}})
}
var staticRenderFns = []

export { render, staticRenderFns }